<h2 *ngIf="fichaCadastro.tipoSolicitante === 'VENDEDOR'">Informações da Loja e do Vendedor</h2>
<h2 *ngIf="fichaCadastro.tipoSolicitante !== 'VENDEDOR'">Informações do Vendedor</h2>
<form #formSelectVendedor="ngForm">
  <div *ngIf="fichaCadastro.tipoSolicitante === 'VENDEDOR' || fichaCadastro.tipoSolicitante === null" class="row">
    <div class="form-group">
      <span class="icon store"></span>
      <div class="inputs">
        <label for="seller-store">Nome da Loja</label>
        <select [(ngModel)]="fichaCadastro.IDLojista" required appShowErrorMessages requiredMessage="Selecionar Nome da Loja é obrigatório"
          name="seller-store" class="form-control" (change)="onChangeListaLojista()">
          <option value="" disabled>Selecione...</option>
          <option *ngFor="let lojista of listaLojistas" value="{{ lojista.id }}">{{ lojista.nome }}</option>
        </select>
        <span *ngIf="!isListaLojistas">
          <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Carregando...
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <span class="icon user"></span>
      <div class="inputs">
        <label for="seller-name">Nome do Vendedor</label>
        <select [(ngModel)]="fichaCadastro.IDVendedor" name="seller-name" class="form-control" id="seller-name"
          required appShowErrorMessages requiredMessage="Selecionar Vendedor é obrigatório">
          <option value="" disabled>Selecione...</option>
          <option *ngFor="let vendedor of listaVendedores" value="{{ vendedor.id }}">{{ vendedor.nome }}</option>
          <option *ngIf="isListaVendedores" value="0">Não cadastrado</option>
        </select>
        <span *ngIf="!isListaVendedores">
          <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Carregando...
        </span>
      </div>
    </div>
  </div>
</form>
<div class="row">
  <div class="marginT30 form-group tab-buttons">
    <a (click)="onClickPrevious()" class="bt-back btn btn-border-orange pull-left">
      <em class="fa fa-arrow-left mrBt"></em>
      Voltar
    </a>
    <a class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': !formSelectVendedor.valid}" (click)="onClickNext()">
      Continuar
      <em class="fa fa-arrow-right mlBt"></em>
    </a>
  </div>
</div>

<app-modal-message #modalMessage title="Atenção!" [hideClose]="true"></app-modal-message>
